export const HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};
